import {
  Box,
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
  CheckboxProps,
} from "@mui/material";
import React from "react";

interface CheckboxConfig {
  label: string;
}

interface MultiCheckboxProps {
  label: string;
  formControlLabelProps?: FormControlLabelProps;
  checkboxProps?: CheckboxProps;
  checkboxes: CheckboxConfig[];
  checked: boolean[];
  handleParentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChildChange: (
    index: number
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const MultiCheckbox: React.FC<MultiCheckboxProps> = ({
  label,
  formControlLabelProps,
  checkboxProps,
  checkboxes,
  checked,
  handleParentChange,
  handleChildChange,
}) => {
  const allChecked = checked.every(Boolean);
  const someChecked = checked.some(Boolean) && !allChecked;

  return (
    <>
      <FormControlLabel
        label={label}
        control={
          <Checkbox
            checked={allChecked}
            indeterminate={someChecked}
            onChange={handleParentChange}
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 20,
              },
            }}
            {...checkboxProps}
          />
        }
        {...formControlLabelProps}
      />
      <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
        {checkboxes.map((checkbox, index) => (
          <FormControlLabel
            key={index}
            label={checkbox.label}
            control={
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 20,
                  },
                }}
                checked={checked[index]}
                onChange={handleChildChange(index)}
              />
            }
          />
        ))}
      </Box>
    </>
  );
};

export default MultiCheckbox;
